import React, { useContext, useState, useEffect } from 'react'
import { HeaderTitle, Loading } from '../Library'
import { NotifyContext } from '../Library/Notify'
import { Form, Row, Col, Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext'
import { createBuilding, listPackages } from '../Network/Administration'
import "./CreateBuilding.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { baseURL } from '../Network/Config'
import Resizer from 'react-image-file-resizer'
import dayjs from 'dayjs'

function CreateBuilding() {
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const history = useHistory()

    const [isLoading, setLoading] = useState(false)
    const [buildingName, setBuildingName] = useState("")
    const [address, setAddress] = useState("")
    const [isError, setError] = useState(false)
    const [isFinish, setIsFinish] = useState(false)
    const [defaultData, setDefaultData] = useState(null)
    const [logo, setLogo] = useState(null)

    const [packageList, setPackageList] = useState([])
    const [selectPackage, setSelectPackage] = useState("")

    const submit = () =>{
        if(!buildingName || !address || !selectPackage){
            setError(true)
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            return
        }

        setLoading(true)
        createBuilding(buildingName, address, selectPackage, logo,
            (data)=>{
                setIsFinish(true)
                setDefaultData(data)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const fetchPackage = () =>{
        listPackages(
            (data)=>{
                setPackageList(data)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            }
        )
    }

    useEffect(()=>{
        fetchPackage()
    },[])

    return (
        <div id="create-building">
            { isLoading ? <Loading/>: null }
            { !isFinish ?
            <div>
                <HeaderTitle 
                title={lang.add_building}
                description={lang.add_building_desc} 
                isShowBack 
                backTo="/buildings"/>
                <Row>
                    <Col md={10} lg={8} xl={6}>
                        <Form 
                        onSubmit={(e)=>{
                            e.preventDefault()
                            submit()
                        }}>
                            <Form.Group>
                                <Form.Label>{lang.building_name}</Form.Label>
                                <Form.Control
                                value={buildingName}
                                onChange={(e)=>setBuildingName(e.target.value)}
                                isInvalid={!buildingName && isError}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.address}</Form.Label>
                                <Form.Control 
                                as="textarea"
                                value={address}
                                onChange={(e)=>setAddress(e.target.value)}
                                isInvalid={!address && isError}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.packages}</Form.Label>
                                <Form.Control 
                                isInvalid={isError && !selectPackage}
                                onChange={(e)=>setSelectPackage(e.target.value)}
                                as="select">
                                    <option value="">{lang.choose_package}</option>
                                    { packageList.map((item, key) => 
                                    <option value={item.id} key={key}>{item.packageName}</option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.logo}</Form.Label>
                                <Form.File
                                accept="image/png"
                                onChange={(e)=>{
                                    var toUpload = e.target.files[0]
                                    Resizer.imageFileResizer(
                                        toUpload,
                                        150,
                                        150,
                                        "PNG",
                                        100,
                                        0,
                                        (uri)=>{
                                            setLogo(uri)
                                        },
                                        "file",
                                        null,
                                        null
                                    )
                                    
                                }}
                                />
                                <div style={{ color: 'orange' }}>
                                    {"*" + lang.png_only}
                                </div>
                            </Form.Group>
                            <hr/>
                            <Button type="submit">
                                {lang.add_building}
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </div>
            :
            <div className="finish-page">
                <div className="finish-icon">
                    <FontAwesomeIcon icon={faCheckCircle}/>
                </div>
                <div className="finish-title">
                    <div className="title">{lang.complete_building}</div>
                    <div className="desc">{lang.complete_building_desc}</div>
                </div>
                <Row>
                    <Col md={6}>
                        <div className="finish-item">
                            <div className="title">{lang.building}</div>
                            <div>
                                <DetailRow title={lang.building_name} value={defaultData?.building.buildingName}/>
                                <DetailRow title={lang.address} value={defaultData?.building.address}/>
                                <DetailRow title={lang.register_date} value={dayjs(defaultData?.building.createdDate).format("D MMMM YYYY HH:mm")}/>
                            </div>
                        </div>
                        { defaultData?.building.buildingLogo !== null ?
                        <div className="finish-item building-logo">
                            <img src={baseURL + defaultData?.building.buildingLogo} loading="lazy"/>
                            <div style={{ marginTop: 20, textAlign: 'center' }}>
                                {lang.logo}
                            </div>
                        </div>
                        : null
                        }
                    </Col>
                    <Col md={6}>
                        <div className="finish-item">
                            <div className="title">{lang.default_user}</div>
                            <div>
                                <DetailRow title={lang.firstname} value={defaultData?.default_user.firstName}/>
                                <DetailRow title={lang.lastname} value={defaultData?.default_user.lastName}/>
                                <DetailRow title={lang.email} value={defaultData?.default_user.email}/>
                                <DetailRow title={lang.username} value={defaultData?.default_user.username}/>
                                <DetailRow title={lang.password} value={defaultData?.default_user.password}/>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div style={{ textAlign: 'center' }}>
                    <Button onClick={()=>history.push("/buildings")}>
                        {lang.finish}
                    </Button>
                </div>
            </div>
            }
        </div>
    )
}

function DetailRow({ title, value }){
    return(
        <div className="detail-row">
            <div className="detail-title">{title}:</div>
            <div className="detail-val">{value}</div>
        </div>
    )
}

export default CreateBuilding
